// images:
// https://pixabay.com/en/people-girls-women-students-2557396/
// https://pixabay.com/en/workplace-team-business-meeting-1245776/
// https://unsplash.com/photos/cw-cj_nFa14
// https://pixabay.com/en/audience-speech-speaker-1677028/
// https://pixabay.com/en/eating-restaurant-food-meal-lunch-601581/
// https://unsplash.com/photos/XCo6jAqksWg
// https://commons.wikimedia.org/wiki/File:Yoga_Class_at_a_Gym4.JPG
// https://pixabay.com/en/theatre-aysen-chorus-2206583/
export default {
  general: {
    appTitle: 'Výchova k životu',
    gaTrackingId: 'UA-113223352-2',
  },
  navigation: {
    labels: {
      about: 'O nás',
      program: 'Program',
      venue: 'Kontakt',
      sponsors: 'Partneři',
      exhibitors: 'Vystavovatelé',
      chat: 'Chat',
      reportProblem: 'Nahlásit problém',
    },
  },
  pages: {
    about: {
      text: require('./about/text').default,
      gallery: require('./about/gallery').default,
    },
    program: {
      text: require('./program/text').default,
    },
    sponsors: {
      sections: [
        require('./sponsors/partners').default,
        require('./sponsors/medialPartners').default,
        require('./sponsors/schoolPartners').default,
      ],
    },
    exhibitors: {
      list: require('./exhibitors/list').default,
    },
    venue: {
      mapImage: require('./resources/map-min.png'),
      mapLink:
        'https://www.google.sk/maps/place/Orea+Hotel+Voron%C4%9B%C5%BE/@49.1858645,16.582879,17z/data=!3m1!4b1!4m5!3m4!1s0x471295b5b300c387:0x4146a6531d3b40d3!8m2!3d49.185861!4d16.585073?hl=en',
      text: require('./venue/text').default,
      text2: require('./venue/text2').default,
    },
    reportProblem: {},
  },
  data: {
    tracks: require('./data/tracks').default,
    sessions: require('./data/sessions').default,
    presentations: require('./data/presentations').default,
    presenters: require('./data/presenters').default,
  },
  addons: {
    feedback: require('./addons/feedback').default,
    socialShare: require('./addons/socialShare').default,
    chat: require('./addons/chat').default,
  },
  intl: {
    preferredLocales: ['CZ-cz', 'SK-sk', 'EN-en'],
    messages: require('../../intl/messages/cz').default,
  },
  theme: {
    palette: {
      primary1Color: '#4E3206',
    },
    custom: {
      colors: {
        backgroundColor: '#F8E2B5',
      },
    },
  },
}



// WEBPACK FOOTER //
// ./src/content/vychovakzivotu/index.js